import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ChanceListContainer from '../../containers/chancemng/ChanceListContainer';
import ChanceFailListContainer from '../../containers/chance-fail/ChanceFailListContainer';

// 2026-10-11 메뉴 재편: "신규 영업 등록"과 "수주 실패"가 별도 메뉴였다가
// 영업 진행 현황 한 화면 안의 버튼/토글로 들어왔다. 라우트(add, chance-fail)는
// 그대로 살려두고(북마크·알림 링크 호환), 여기서는 url의 view 값으로 상태를 기억한다.
const ChanceListPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get('view') === 'fail' ? 'fail' : 'progress';

  const handleViewChange = (_event, next) => {
    if (!next) return;
    const params = new URLSearchParams(searchParams);
    if (next === 'progress') {
      params.delete('view');
    } else {
      params.set('view', next);
    }
    setSearchParams(params);
  };

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
          pt: 1.5,
          pb: { xs: 1.5, sm: 0 },
        }}
      >
        <ToggleButtonGroup
          value={view}
          exclusive
          size="small"
          onChange={handleViewChange}
          aria-label="영업 상태 보기"
        >
          <ToggleButton value="progress">진행 중</ToggleButton>
          <ToggleButton value="fail">수주 실패</ToggleButton>
        </ToggleButtonGroup>

        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => navigate('/chancemng/add')}
        >
          신규 영업 등록
        </Button>
      </Box>

      {view === 'fail' ? <ChanceFailListContainer /> : <ChanceListContainer />}
    </Box>
  );
};

export default ChanceListPage;
